module.exports = __webpack_public_path__ + "/img/a785878412909b9275afa57c74d34cf4.png";